import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ChevronDown, MapPinFilled } from 'components/Icons';

const RegionButton = styled.button`
  ${(props) => props.theme.typography.bodyBold};
  align-items: center;
  background: none;
  border: none;
  color: ${(props) => props.theme.colors.grayscale.gray0};
  cursor: pointer;
  display: flex;
  height: 100%;
  padding: 0 0.5rem;
  position: relative;

  svg {
    display: block;

    g {
      color: ${(props) => props.theme.colors.grayscale.gray0};
    }
  }
`;

const RegionText = styled.div`
  display: flex;
  padding: 0 0.5rem;

  span {
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const StyledChevron = styled(ChevronDown)`
  height: 1rem;
  width: 1rem;

  & svg {
    height: 100%;
    width: 100%;
  }

  transform: ${(props) =>
    props['data-isopen'] ? 'rotate(0)' : 'rotate(180deg)'};
  transition: transform 0.2s ease-in;
`;

StyledChevron.displayName = 'ChevronDown';

const StyledMapFilled = styled.div`
  height: 1rem;
  width: 1rem;

  & svg {
    height: 100%;
    width: 100%;
  }
`;

function RegionSelectorButton({ selectedItem, isOpen, onClick, ...rest }) {
  const [openState, setOpenState] = useState(isOpen);

  const handleClick = () => {
    setOpenState(!openState);

    if (typeof onClick === 'function') {
      onClick();
    }
  };

  useEffect(() => {
    setOpenState(isOpen);
  }, [isOpen]);

  return (
    <RegionButton
      id="mobile-region-selector-button"
      type="button"
      onClick={handleClick}
      value={selectedItem.title}
      {...rest}
    >
      <StyledMapFilled>
        <MapPinFilled />
      </StyledMapFilled>
      <RegionText id="mobile-region-selector-text">
        <span>{selectedItem.title}</span>
      </RegionText>
      <StyledChevron
        id="mobile-region-selector-chevron-down"
        data-isopen={openState}
      />
    </RegionButton>
  );
}

RegionSelectorButton.displayName = 'RegionSelectorButton';

RegionSelectorButton.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  selectedItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

RegionSelectorButton.defaultProps = {
  isOpen: false,
  onClick: () => {},
};
export default RegionSelectorButton;
